import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import { CloseIcon } from '@seedlang/icons';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { pixify } from '@seedlang/utils';

const Wrapper = styled.div`
  background: ${props => props.background};
  width: ${props => props.width};
  margin: ${props => props.margin};
  border: ${props => props.border};
  color: ${props => props.color};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  position: relative;
  padding: ${props => props.wrapperPadding};
  border-radius: ${props => props.borderRadius};
  text-align: ${props => props.textAlign};
  box-sizing: border-box;
  text-shadow: ${props => ['#fff', '#ffffff', 'white'].includes(`${props.color}`.toLowerCase()) ? '0 1px 2px rgba(17, 90, 112, 0.35)' : 'none'};
  a {
    color: ${props => props.color};
  }
  @media (max-width: 699px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

const Content = styled.div`
  display: block;
  width: 100%;
  padding: ${props => props.padding};
`;

const CloseIconWrapper = styled.div`
  .close-icon {
    position: absolute;
    top: 7px;
    right: 0px;
    z-index: ${props => props.zIndex};
    transform: rotate(0);
    svg {
      width: 16px;
      fill: ${props => props.color};
    }
  }
`;

@observer
class PageOnboarding extends React.Component {
  state = {
    hidden: false,
  };

  static defaultProps = {
    width: '100%',
    margin: '0 0 10px 0',
    background: `linear-gradient(90deg, rgba(59, 215, 197, 0.9) 0%, #0A9FE3 20%, ${Theme.blue} 72%, #678DE0 100%)`,
    border: 'none',
    borderRadius: 12,
    color: '#FFF',
    textAlign: 'center',
    fontSize: 15,
    padding: '0 15px 0 0',
    wrapperPadding: '14px 18px',
  };

  onClose = () => {
    this.setState({ hidden: true });
    AppUI.designateUiElementAsSeen(this.props.uiElement);
  }

  render() {
    if (this.state.hidden) {
      return null;
    }

    return (
      <Wrapper
        fontSize={pixify(this.props.fontSize)}
        lineHeight={pixify(this.props.fontSize + 3)}
        className={this.props.className}
        width={this.props.width}
        margin={this.props.margin}
        border={this.props.border}
        color={this.props.color}
        background={this.props.background}
        textAlign={this.props.textAlign}
        wrapperPadding={this.props.wrapperPadding}
        borderRadius={pixify(this.props.borderRadius)}
      >
        <Content
          padding={this.props.padding}
        >
          {this.props.children}
        </Content>
        {
          !this.props.hideCloseIcon && !this.props.fatCloseIcon &&
          <CloseIconWrapper
            zIndex={Theme.z['foreground']}
            color={this.props.color}
          >
            <CloseIcon
              className='page-onboarding-close-icon'
              onClick={this.onClose}
              fill={this.props.color}
            />
          </CloseIconWrapper>
        }
        {
          !this.props.hideCloseIcon && this.props.fatCloseIcon &&
          <i
            className='fa fa-times'
            style={{ color: this.props.color, opacity: 0.85 }}
            onClick={this.onClose}
          />
        }
      </Wrapper>
    );
  }
}

export default PageOnboarding;
